import { render, staticRenderFns } from "./ag-status-bar-actions.vue?vue&type=template&id=4211d983"
import script from "./ag-status-bar-actions.vue?vue&type=script&lang=js"
export * from "./ag-status-bar-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports